<template>
  <div>
    <header class="db-page-head">
      <div>
        <h2 class="db-page-title">Horarios</h2>
        <p class="db-page-subtitle">
          Cada bloque es un conjunto de horarios (p. ej. invierno o verano). En la web se muestran primero los visibles.
        </p>
      </div>
      <div class="db-actions">
        <span v-if="hayCambios" class="db-badge db-badge--warning">
          <span class="material-symbols-outlined">edit</span> Cambios sin guardar
        </span>
        <button v-if="hayCambios" type="button" class="db-btn db-btn--ghost" :disabled="guardando" @click="descartar">
          Descartar
        </button>
        <button type="button" class="db-btn" :disabled="!hayCambios || guardando" @click="GuardarCambios">
          <span v-if="guardando" class="db-spinner"></span>
          <span v-else class="material-symbols-outlined">save</span>
          Guardar cambios
        </button>
      </div>
    </header>

    <div v-if="loading" class="eh-list">
      <div v-for="n in 2" :key="n" class="db-skeleton" style="height: 200px"></div>
    </div>

    <div v-else class="eh-list">
      <section v-for="(item, index) in horarios" :key="item.id || index" class="db-card eh-block">
        <!-- Cabecera del bloque -->
        <div class="db-card-head eh-block-head">
          <button
            type="button"
            class="db-icon-btn"
            :aria-expanded="!plegado(index)"
            :aria-label="plegado(index) ? 'Desplegar bloque' : 'Plegar bloque'"
            @click="togglePlegado(index)"
          >
            <span class="material-symbols-outlined">{{ plegado(index) ? "chevron_right" : "expand_more" }}</span>
          </button>
          <input
            v-model="item.titulo"
            type="text"
            class="db-input eh-block-title"
            placeholder="Nombre del bloque (p. ej. Horario de invierno)"
            aria-label="Nombre del bloque"
          />
          <label class="db-switch">
            <input v-model="item.activo" type="checkbox" />
            <span class="db-switch-track"></span>
            Visible
          </label>
          <button
            type="button"
            class="db-icon-btn db-icon-btn--danger"
            title="Eliminar bloque"
            aria-label="Eliminar bloque"
            @click="eliminarHorario(index)"
          >
            <span class="material-symbols-outlined">delete</span>
          </button>
        </div>

        <!-- Eventos -->
        <div v-show="!plegado(index)" class="db-card-body eh-events">
          <p v-if="!item.element.length" class="db-hint">Este bloque no tiene celebraciones todavía.</p>

          <div v-for="(evento, indexEvento) in item.element" :key="indexEvento" class="eh-event">
            <div class="eh-event-head">
              <span class="material-symbols-outlined eh-event-icon">event</span>
              <input
                v-model="evento.evento"
                type="text"
                class="db-input eh-event-name"
                placeholder="Celebración (p. ej. Santa Misa)"
                aria-label="Nombre de la celebración"
              />
              <button
                type="button"
                class="db-icon-btn"
                title="Subir"
                aria-label="Subir celebración"
                :disabled="indexEvento === 0"
                @click="mover(item.element, indexEvento, -1)"
              >
                <span class="material-symbols-outlined">arrow_upward</span>
              </button>
              <button
                type="button"
                class="db-icon-btn"
                title="Bajar"
                aria-label="Bajar celebración"
                :disabled="indexEvento === item.element.length - 1"
                @click="mover(item.element, indexEvento, 1)"
              >
                <span class="material-symbols-outlined">arrow_downward</span>
              </button>
              <button
                type="button"
                class="db-icon-btn db-icon-btn--danger"
                title="Eliminar celebración"
                aria-label="Eliminar celebración"
                @click="eliminarFila(item.element, indexEvento)"
              >
                <span class="material-symbols-outlined">delete</span>
              </button>
            </div>

            <div class="eh-rows">
              <div v-for="(itemInt, indexdata) in evento.values" :key="indexdata" class="eh-row">
                <input v-model="itemInt[0]" type="text" class="db-input" placeholder="Días (p. ej. Lunes a viernes)" aria-label="Días" />
                <input v-model="itemInt[1]" type="text" class="db-input eh-row-time" placeholder="Hora (opcional)" aria-label="Hora" />
                <button
                  type="button"
                  class="db-icon-btn db-icon-btn--danger"
                  title="Quitar fila"
                  aria-label="Quitar fila"
                  @click="eliminarFila(evento.values, indexdata)"
                >
                  <span class="material-symbols-outlined">remove</span>
                </button>
              </div>
              <button type="button" class="db-btn db-btn--ghost db-btn--sm eh-add-row" @click="aniadirFila(evento.values)">
                <span class="material-symbols-outlined">add</span> Añadir horario
              </button>
            </div>
          </div>

          <button type="button" class="db-btn db-btn--ghost eh-add-event" @click="aniadirevento(item.element)">
            <span class="material-symbols-outlined">add_circle</span> Añadir celebración
          </button>
        </div>
      </section>

      <button type="button" class="db-add-card eh-add-block" @click="sumarHorario">
        <span class="material-symbols-outlined">add</span>
        Nuevo bloque de horarios
      </button>
    </div>
  </div>
</template>

<script>
import axios from "@/directives/axios.js";
import { confirmar, avisar, avisarError } from "@/directives/dbDialogs.js";

export default {
  name: "editorHorarios",

  data() {
    return {
      horarios: [],
      original: "[]",
      plegados: [],
      loading: true,
      guardando: false,
    };
  },
  computed: {
    hayCambios() {
      return JSON.stringify(this.horarios) !== this.original;
    },
  },
  mounted() {
    this.obtenerHorarios();
    window.addEventListener("beforeunload", this.avisoSalida);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.avisoSalida);
  },
  methods: {
    avisoSalida(e) {
      if (this.hayCambios) {
        e.preventDefault();
        e.returnValue = "";
      }
    },
    plegado(index) {
      return this.plegados.includes(index);
    },
    togglePlegado(index) {
      this.plegados = this.plegado(index) ? this.plegados.filter((i) => i !== index) : [...this.plegados, index];
    },
    aniadirevento(item) {
      item.push({ evento: "", values: [["", ""]] });
    },
    async eliminarHorario(index) {
      const bloque = this.horarios[index];
      const ok = await confirmar(this, `Se quitará el bloque «${bloque.titulo || "sin nombre"}». No se borrará hasta que pulses "Guardar cambios".`, {
        titulo: "Quitar bloque",
        ok: "Quitar",
        peligro: true,
      });
      if (!ok) return;
      this.horarios.splice(index, 1);
      this.plegados = [];
      avisar(this, 'Pulsa "Guardar cambios" para que se aplique en la web.', "info", "Bloque quitado");
    },
    eliminarFila(array, index) {
      array.splice(index, 1);
    },
    mover(array, index, delta) {
      const destino = index + delta;
      if (destino < 0 || destino >= array.length) return;
      const [el] = array.splice(index, 1);
      array.splice(destino, 0, el);
    },
    aniadirFila(horariosEvento) {
      horariosEvento.push(["", ""]);
    },
    sumarHorario() {
      this.horarios.push({
        activo: false,
        element: [],
        id: "item" + Date.now(),
        titulo: "",
      });
    },
    async obtenerHorarios() {
      try {
        const { data } = await axios.get("/horario/horarios");
        this.horarios = (data.horarios || []).map((h) => ({ ...h, element: h.element || [] }));
        this.original = JSON.stringify(this.horarios);
      } catch (error) {
        avisarError(this, error, "No se pudieron cargar los horarios.");
      } finally {
        this.loading = false;
      }
    },
    async descartar() {
      const ok = await confirmar(this, "Se perderán los cambios que no hayas guardado.", {
        titulo: "Descartar cambios",
        ok: "Descartar",
        peligro: true,
      });
      if (!ok) return;
      this.horarios = JSON.parse(this.original);
      this.plegados = [];
    },
    async GuardarCambios() {
      this.guardando = true;
      try {
        await axios.post("/horario", { horarios: this.horarios });
        avisar(this, "Los cambios ya se ven en la portada de la web.", "success", "Horarios guardados");
        await this.obtenerHorarios();
      } catch (error) {
        avisarError(this, error, "No se pudieron guardar los horarios.");
      } finally {
        this.guardando = false;
      }
    },
  },
};
</script>

<style scoped>
.eh-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.eh-block-head {
  flex-wrap: nowrap;
  gap: 10px;
}

.eh-block-title {
  flex: 1;
  min-width: 0;
  font-weight: 600;
}

@media (max-width: 640px) {
  .eh-block-head {
    flex-wrap: wrap;
  }

  .eh-block-title {
    flex-basis: calc(100% - 50px);
  }
}

.eh-events {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.eh-event {
  padding: 14px;
  border: 1px solid var(--sd-border);
  border-radius: 12px;
  background: var(--sd-surface-2);
}

.eh-event-head {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
}

.eh-event-icon {
  color: var(--sd-primary) !important;
}

.eh-event-name {
  flex: 1;
  min-width: 0;
  font-weight: 600;
}

.eh-rows {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-left: 28px;
}

.eh-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.eh-row .db-input {
  flex: 2;
  min-width: 0;
  height: 38px;
}

.eh-row .eh-row-time {
  flex: 1;
}

.eh-add-row {
  align-self: flex-start;
}

.eh-add-event {
  align-self: flex-start;
}

.eh-add-block {
  min-height: 90px;
  flex-direction: row;
}

@media (max-width: 640px) {
  .eh-rows {
    padding-left: 0;
  }

  .eh-row {
    flex-wrap: wrap;
  }

  .eh-row .db-input {
    flex-basis: 100%;
  }
}
</style>
